 window.addEventListener('load', (event) => {
  var queryString = window.location.search;
  var querypathname = window.location.pathname ;
  var myHandelCurr;
  if (querypathname.startsWith("/fr/")) {
      myHandelCurr = querypathname.substring(13);
  } else {
      myHandelCurr = querypathname.substring(10);
  }

  var urlParams = new URLSearchParams(queryString); 
  //var year = urlParams.get('year');
  //var make = urlParams.get('make');
  //var model = urlParams.get('model');
  
  var year = localStorage.getItem('GYear');
  var make = localStorage.getItem('GMake');
  var model = localStorage.getItem('GModel');
  
  
  var FitVehicle = document.getElementById("FitVehicle");
  var NotFitVehicle = document.getElementById("NotFitVehicle");
  var VehicleUnknown = document.getElementById("VehicleUnknown");

  var installationKit = document.getElementById("installation-kit");
   
  VehicleUnknown.style.display = 'none';
  FitVehicle.style.display = 'none';
  NotFitVehicle.style.display = 'none';
  installationKit.style.display = 'none';
  
  var subModel = urlParams.get('subModel');
   
   if(subModel != null){ localStorage.setItem('GSubModel',subModel); }
  
  var CurrLanguage = window.location.pathname.substring(0,4);
  var codeLG = 0;
  if(CurrLanguage == "/fr/"){
    codeLG = 1;
  } 

  
  var changeVehicleLink = document.getElementById("changeVehicleLink");
  if(changeVehicleLink != null){ changeVehicleLink.addEventListener("click", function(){ chanVehicle(); }); }
  
  var thibertPartNumber = document.getElementById("thibertPartNumber").innerText.replace(/\s/g,''); 
  var linkDataPartNumber = apiURL+'/api/WhiteLabel/Parts/IsVehicleSpecific/'+thibertPartNumber;
  var dataThibertPartNumber = fetch(linkDataPartNumber, {
    method: 'GET',
    headers: {     
      "content-encoding": "gzip", 
      "content-length": "754",
      "content-type": "application/json; charset=utf-8", 
      "date": "Wed,01 Sep 2021 18:16:58 GMT",
      "request-context": "appId=cid-v1:c332b3e3-0008-434d-abd9-a1d6ea35f0dc",
      "server": "Microsoft-IIS/10.0",
      "vary": "Accept-Encoding", 
      "x-powered-by": "ASP.NET",
      "accept": "text/plain",
      "x-api-key": apiKey,
      "Authorization": apiKey
    }
  })
  .then(res => res.json())
  .then(data => {    
      if(data.isVehicleSpecific == false){
          VehicleUnknown.style.display = 'none';
          FitVehicle.style.display = 'none';
          NotFitVehicle.style.display = 'none';
      }else if(subModel == null){
        changeVehicle.click();
        VehicleUnknown.style.display = 'block';
        FitVehicle.style.display = 'none';
        NotFitVehicle.style.display = 'none';
      }
  });
  
  
  var partTypeNumber = urlParams.get('partNumber');
  var URLfitVehicle = urlParams.get('fitVehicle');
  var kitIncluded = urlParams.get('kitIncluded');
  var partNumber = '';
  
  //if((partTypeNumber != null) && (partTypeNumber != '')){ installationKit.style.display = 'block'; }
   
  if(kitIncluded == "true"){
  	var kitIncluded = document.getElementById("kitIncluded");
  	var svgButtonKit = document.getElementById("svgButtonKit");
  	kitIncluded.style.display = 'block';
  	svgButtonKit.style.display = 'block';
    kitIncluded.classList.add("activeKit");
  }
  
  var nameVehicle = document.getElementById("nameVehicle");
  var nameVehicleNotFit = document.getElementById("nameVehicleNotFit");
  var VehicleUnknown = document.getElementById("VehicleUnknown");
  
  var NotFitVehicle = document.getElementById("NotFitVehicle");
  var fullVehicleName = year + ' ' + make + ' ' + model;
  
  
  if((subModel != null) && (subModel != '')){ 
    nameVehicle.value = fullVehicleName + ' ' + subModel;
    nameVehicle.innerText = fullVehicleName + ' ' + subModel;
    
    nameVehicleNotFit.value = fullVehicleName;
    nameVehicleNotFit.innerText = fullVehicleName;
    
    
    if(URLfitVehicle == 'False'){
      FitVehicle.style.display = 'none';
      NotFitVehicle.style.display = 'block';
      VehicleUnknown.style.display = 'none';
    }else{ 
      FitVehicle.style.display = 'block';
      NotFitVehicle.style.display = 'none';
      VehicleUnknown.style.display = 'none';
    }
  } 
  
  if((URLfitVehicle != null) && (URLfitVehicle != '')){ 
    nameVehicle.value = fullVehicleName;
    nameVehicle.innerText = fullVehicleName;
    
    nameVehicleNotFit.value = fullVehicleName;
    nameVehicleNotFit.innerText = fullVehicleName;
    
    
    if(URLfitVehicle == 'False'){
      FitVehicle.style.display = 'none';
      NotFitVehicle.style.display = 'block';
      VehicleUnknown.style.display = 'none';
    }else{ 
      FitVehicle.style.display = 'block';
      NotFitVehicle.style.display = 'none';
      VehicleUnknown.style.display = 'none';
    }
  } 
  
  
  
  var vehicleContent = document.getElementById("vehicle-content");
  var countInstallationKit = 0;

  if(subModel != null){
    var link = apiURL+'/api/WhiteLabel/Products/InstallationPartsByVehicle/'+year+'/'+make+'/'+model+'/'+subModel+'/'+partTypeNumber;    
    var data = fetch(link, {
      method: 'GET',
      headers: {     
        "content-encoding": "gzip", 
        "content-length": "754",
        "content-type": "application/json; charset=utf-8", 
        "date": "Wed,01 Sep 2021 18:16:58 GMT",
        "request-context": "appId=cid-v1:c332b3e3-0008-434d-abd9-a1d6ea35f0dc",
        "server": "Microsoft-IIS/10.0",
        "vary": "Accept-Encoding", 
        "x-powered-by": "ASP.NET",
        "accept": "text/plain",
        "x-api-key": apiKey,
        "Authorization": apiKey
      }
    })
    .then(res => res.json())
    .then(data => { 
        
        data.forEach(Data => {
          countInstallationKit++;
          var newTable = document.createElement("table");
          var newTr1 = document.createElement("tr");
          var newTd1Img = document.createElement("td");
          var newTd1P = document.createElement("td");

          var vImg = document.createElement("img");
          vImg.src = Data.imageURL;
          newTd1Img.appendChild(vImg);
          newTr1.appendChild(newTd1Img);

          var vP = document.createElement("a");
          vP.value = Data.titleEN;
          vP.innerText = Data.titleEN;
      vP.href = Data.handle;
          vP.target="_blank";
          newTd1P.appendChild(vP);

          
          
          var vBR = document.createElement("br");
          newTd1P.appendChild(vBR);
          
          var vLabel = document.createElement("label");
          vLabel.value = Data.price;
          vLabel.innerText = Data.price;
          newTd1P.appendChild(vLabel);
    
          var vForm = document.createElement("form");
          vForm.method = "post";
          vForm.action = "/cart/add";
          vForm.class = "smart-payment-enabled";
          vForm.enctype = "multipart/form-data";
          vForm.id = "product_form_" + Data.shopProductID;
          
          
          var vInputId = document.createElement("input");
          vInputId.type = "hidden";
          vInputId.name = "id";
          vInputId.value = Data.shopProductVariantID;
          vForm.appendChild(vInputId);
          
          
          var vInputQty = document.createElement("input");
          vInputQty.type = "hidden";
          vInputQty.name = "quantity";
          vInputQty.value = "1";
          vInputQty.id = "quantity";
          vForm.appendChild(vInputQty);


          // encode the url with encodeURIComponent that will encode and replace the spaces with something like %20
          var subModelEncode = encodeURIComponent(subModel);
          var vInputGoBack = document.createElement("input");
          vInputGoBack.type = "hidden";
          vInputGoBack.name = "return_to";
          vInputGoBack.value = "products/" + myHandelCurr + "?subModel=" + subModelEncode + "&partNumber=" + partTypeNumber + "&kitIncluded=true"
          
   
          vForm.appendChild(vInputGoBack);
          
          var vInputSubmit = document.createElement("input");
          vInputSubmit.type = "submit";
          vInputSubmit.value = "ADD TO CART";
          vInputSubmit.id = "addKit";
          vForm.appendChild(vInputSubmit);
          
          newTd1P.appendChild(vForm);
          
          newTr1.appendChild(newTd1P);

          newTable.appendChild(newTr1);

          vehicleContent.append(newTable);
      
                
      });
                
    });
  }
  setTimeout(function(){ 
    if(countInstallationKit == 0){ 
    	installationKit.style.display = "none";
    }else{
    	installationKit.style.display = "block";
    }
  }, 1000);
  
var closeModal = document.getElementById("closeModal");
  
closeModal.addEventListener("click", function(){
  modal_container.classList.remove('show');
}); 
  
  
var includeKit = document.getElementById("includeKit");
includeKit.addEventListener("click", function(){
  modal_container.classList.add('show');
}); 
  
  
var modal_container_change = document.getElementById("modal_container_change");
var closeModalChange = document.getElementById("closeModal-change");
  
closeModalChange.addEventListener("click", function(){
  modal_container_change.classList.remove('show');
}); 
  
  
  
  
  
var changeVehicle = document.getElementById("changeVehicle");
changeVehicle.addEventListener("click", function(){
  chanVehicle();
}); 
  
 
var changeVehicleNotFit = document.getElementById("changeVehicleNotFit");
changeVehicleNotFit.addEventListener("click", function(){
  chanVehicle();
}); 
  
var unknownFit = document.getElementById("unknownFit");
unknownFit.addEventListener("click", function(){
  chanVehicle();
});  
  
  
function chanVehicle(){
modal_container_change.classList.add('show');
  
  
   var selectOption1 = document.getElementById("selectOption1");
   var selectOption2 = document.getElementById("selectOption2");
   var selectOption3 = document.getElementById("selectOption3");
   var selectOption4 = document.getElementById("selectOption4");
   var selectOption5 = document.getElementById("selectOption5");
   var selectOption6 = document.getElementById("selectOption6");
   var selectOption7 = document.getElementById("selectOption7");
   var selectOption8 = document.getElementById("selectOption8");
  
  selectOption1.style.display = "block";
  selectOption2.style.display = "none";
  selectOption3.style.display = "none";
  selectOption4.style.display = "none";
  selectOption5.style.display = "none";
  selectOption6.style.display = "none";
  selectOption7.style.display = "none";
  selectOption8.style.display = "none";
  
  
  var option1Li = document.getElementById("option1Li");
  var option2Li = document.getElementById("option2Li");
  var option3Li = document.getElementById("option3Li");
  var option4Li = document.getElementById("option4Li");
  var option5Li = document.getElementById("option5Li");
  var option6Li = document.getElementById("option6Li");
  var option7Li = document.getElementById("option7Li");
  var option8Li = document.getElementById("option8Li");
  
    
  option2Li.style.display = "none";
  option3Li.style.display = "none";
  option4Li.style.display = "none";
  option5Li.style.display = "none";
  option6Li.style.display = "none";
  option7Li.style.display = "none";
  option8Li.style.display = "none";
  
  
  var option1LiText = document.getElementById("option1LiText"); 
  var option2LiText = document.getElementById("option2LiText"); 
  var option3LiText = document.getElementById("option3LiText"); 
  var option4LiText = document.getElementById("option4LiText"); 
  var option5LiText = document.getElementById("option5LiText"); 
  var option6LiText = document.getElementById("option6LiText"); 
  var option7LiText = document.getElementById("option7LiText"); 
  var option8LiText = document.getElementById("option8LiText"); 
  
  option1LiText.innerText = 'Not selected';
  option2LiText.innerText = 'Not selected';
  option3LiText.innerText = 'Not selected';
  option4LiText.innerText = 'Not selected';
  option5LiText.innerText = 'Not selected';
  option6LiText.innerText = 'Not selected';
  option7LiText.innerText = 'Not selected';
  option8LiText.innerText = 'Not selected';
  
  
  var idGo = document.getElementById("idGo");
  idGo.style.display = 'none';
  
  var vehicleSelected = document.getElementById("vehicleSelected");
  vehicleSelected.innerText = 'Vehicle';
  
   var selectOption1 = document.getElementById("selectOption1");
    selectOption1.innerText = '';
    var option = document.createElement("option");
    option.value = 'Year';
    option.innerText = 'Year';
    option.type = 'Hidden'
    selectOption1.append(option);
  
   var link = apiURL+'/api/WhiteLabel/Vehicle/Years';
    var data = fetch(link, {

    method: 'GET',
    headers: {     
      "content-encoding": "gzip", 
      "content-length": "247",
      "content-type": "application/json; charset=utf-8", 
      "date": "Fri,30 Apr 2021 13:15:47 GMT",
      "request-context": "appId=cid-v1:c332b3e3-0008-434d-abd9-a1d6ea35f0dc",
      "server": "Microsoft-IIS/10.0",
      "vary": "Accept-Encoding", 
      "x-powered-by": "ASP.NET",
      "accept": "text/plain",
      "x-api-key": apiKey,
      "Authorization": apiKey
      }
  })
  .then(res => res.json())
  .then(data => { 
    data.forEach(Data => {    
      var selectOption = document.getElementById("selectOption1");
      var option = document.createElement("option");
      option.value = Data;
      option.innerText = Data;
      selectOption.append(option);
    });
  });

} 
   
var selectOption1 = document.getElementById("selectOption1");
if(selectOption1 != null){ selectOption1.addEventListener("change", function(){ option1Function(); }); }

var selectOption2 = document.getElementById("selectOption2");
if(selectOption2 != null){ selectOption2.addEventListener("change", function(){ option2Function(); }); }

var selectOption3 = document.getElementById("selectOption3");
if(selectOption3 != null){ selectOption3.addEventListener("change", function(){ option3Function(); }); }

var selectOption4 = document.getElementById("selectOption4");
if(selectOption4 != null){ selectOption4.addEventListener("change", function(){ option4Function(); }); }

var selectOption5 = document.getElementById("selectOption5");
if(selectOption5 != null){ selectOption5.addEventListener("change", function(){ option5Function(); }); }

var selectOption6 = document.getElementById("selectOption6");
if(selectOption6 != null){ selectOption6.addEventListener("change", function(){ option5Function(); }); }

var selectOption7 = document.getElementById("selectOption7");
if(selectOption7 != null){ selectOption7.addEventListener("change", function(){ option7Function(); }); }

var selectOption8 = document.getElementById("selectOption8");
if(selectOption8 != null){ selectOption8.addEventListener("change", function(){ option8Function(); }); }

   
function option1Function(){
  
   var selectOption1 = document.getElementById("selectOption1");
   var selectOption2 = document.getElementById("selectOption2");
  
    selectOption2.innerText = '';
    var option = document.createElement("option");
    option.value = 'Make';
    option.innerText = 'Make';
    option.type = 'Hidden'
    selectOption2.append(option);
  
  selectOption1.style.display = "none";
  selectOption2.style.display = "block";
  
  var optionLiText = document.getElementById("option1LiText");
  optionLiText.innerText = selectOption1.value;
  optionLiText.value = selectOption1.value;
  
  
  var vehicleSelected = document.getElementById("vehicleSelected");
  vehicleSelected.innerText = '';
  vehicleSelected.append(selectOption1.value);
  
   var link = apiURL+'/api/WhiteLabel/Vehicle/Makes/'+selectOption1.value;
    var data = fetch(link, {

    method: 'GET',
    headers: {     
      "content-encoding": "gzip", 
      "content-length": "247",
      "content-type": "application/json; charset=utf-8", 
      "date": "Fri,30 Apr 2021 13:15:47 GMT",
      "request-context": "appId=cid-v1:c332b3e3-0008-434d-abd9-a1d6ea35f0dc",
      "server": "Microsoft-IIS/10.0",
      "vary": "Accept-Encoding", 
      "x-powered-by": "ASP.NET",
      "accept": "text/plain",
      "x-api-key": apiKey,
      "Authorization": apiKey
      }
  })
  .then(res => res.json())
  .then(data => { 
    data.forEach(Data => {
    
      option2Li.style.display = "block";
      var selectOption = document.getElementById("selectOption2");
      var option = document.createElement("option");
      option.value = Data;
      option.innerText = Data;
      selectOption.append(option);
    });
  });
}
function option2Function(){
	
   var selectOption1 = document.getElementById("selectOption1");
   var selectOption2 = document.getElementById("selectOption2");
   var selectOption3 = document.getElementById("selectOption3");
  
    selectOption3.innerText = '';
    var option = document.createElement("option");
    option.value = 'Model';
    option.innerText = 'Model';
    option.type = 'Hidden'
    selectOption3.append(option);
  
  
  selectOption1.style.display = "none";
  selectOption2.style.display = "none";
  selectOption3.style.display = "block";
  
  var optionLiText = document.getElementById("option2LiText");
  optionLiText.innerText = selectOption2.value;
  optionLiText.value = selectOption2.value;
  
  
  var vehicleSelected = document.getElementById("vehicleSelected");
  vehicleSelected.append(' ' + selectOption2.value);
  
   var link = apiURL+'/api/WhiteLabel/Vehicle/Models/'+selectOption1.value+'/'+selectOption2.value;
    var data = fetch(link, {

    method: 'GET',
    headers: {     
      "content-encoding": "gzip", 
      "content-length": "247",
      "content-type": "application/json; charset=utf-8", 
      "date": "Fri,30 Apr 2021 13:15:47 GMT",
      "request-context": "appId=cid-v1:c332b3e3-0008-434d-abd9-a1d6ea35f0dc",
      "server": "Microsoft-IIS/10.0",
      "vary": "Accept-Encoding", 
      "x-powered-by": "ASP.NET",
      "accept": "text/plain",
      "x-api-key": apiKey,
      "Authorization": apiKey
      }
  })
  .then(res => res.json())
  .then(data => { 
    data.forEach(Data => {
    
      option3Li.style.display = "block";
      var selectOption = document.getElementById("selectOption3");
      var option = document.createElement("option");
      option.value = Data;
      option.innerText = Data;
      selectOption.append(option);
    });
  });
}
function option3Function(){
	
   var selectOption1 = document.getElementById("selectOption1");
   var selectOption2 = document.getElementById("selectOption2");
   var selectOption3 = document.getElementById("selectOption3");
   var selectOption4 = document.getElementById("selectOption4");
  selectOption1.style.display = "none";
  selectOption2.style.display = "none";
  selectOption3.style.display = "none";
  selectOption4.style.display = "block";
  
  var optionLiText = document.getElementById("option3LiText");
  optionLiText.innerText = selectOption3.value;
  optionLiText.value = selectOption3.value;
  
  var vehicleSelected = document.getElementById("vehicleSelected");
  vehicleSelected.append(' ' + selectOption3.value);
  
  var arrModel = [];
  
  
  partNumber = partTypeNumber;
  if((partNumber == null) || (partNumber == '')){  
    partNumber = '' + thibertPartNumber; 
    }
   
  
  if(partNumber.length == 5){
    partNumber = '0' + partNumber;
  }
  
   
    var myCounter = 0;
  
  localStorage.setItem('GYear',selectOption1.value);
  localStorage.setItem('GMake',selectOption2.value);
  localStorage.setItem('GModel',selectOption3.value);
  var link = apiURL+'/api/WhiteLabel/Questions/QuestionsByVehicleAndProduct/'+
      selectOption1.value+'/'+selectOption2.value+'/'+selectOption3.value+'/'+2+'/'+partNumber;
    var data = fetch(link, {

    method: 'GET',
    headers: {     
      "content-encoding": "gzip", 
      "content-length": "247",
      "content-type": "application/json; charset=utf-8", 
      "date": "Fri,30 Apr 2021 13:15:47 GMT",
      "request-context": "appId=cid-v1:c332b3e3-0008-434d-abd9-a1d6ea35f0dc",
      "server": "Microsoft-IIS/10.0",
      "vary": "Accept-Encoding", 
      "x-powered-by": "ASP.NET",
      "accept": "text/plain",
      "x-api-key": apiKey,
      "Authorization": apiKey
      }
  })
  .then(res => res.json())
  .then(data => { 
    data.questionsAnswers.forEach(Data => {
    if(myCounter == 0){
      
      
      option4Li.style.display = "block";
      
      var OptionHidden4 = document.getElementById("OptionHidden4");
      OptionHidden4.innerText = Data.question1[codeLG].localizedValue;
    }
    if(arrModel.includes(Data.answers1[codeLG].localizedValue) == false){  
      arrModel.push(Data.answers1[codeLG].localizedValue);  
      var selectOption = document.getElementById("selectOption4");
      var option = document.createElement("option");
      option.value = Data.answers1[codeLG].localizedValue;
      option.innerText = Data.answers1[codeLG].localizedValue;
      selectOption.append(option);

      myCounter++;
      }
    });
  });
  setTimeout(function(){ 
    if(myCounter == 0){
    	location.href = '?subModel=' + selectOption4.value + '&partNumber=' + partNumber + '&fitVehicle=False';
    }
  }, 1000);
  
}
function option4Function(){

   	var selectOption1 = document.getElementById("selectOption1");
    var selectOption2 = document.getElementById("selectOption2");
    var selectOption3 = document.getElementById("selectOption3");
    var selectOption4 = document.getElementById("selectOption4"); 
    var selectOption5 = document.getElementById("selectOption5"); 
    selectOption1.style.display = "none";
    selectOption2.style.display = "none";
    selectOption3.style.display = "none";
    selectOption4.style.display = "none";
    
  var optionLiText = document.getElementById("option4LiText");
  optionLiText.innerText = selectOption4.value;
  optionLiText.value = selectOption4.value;
  
  
  var vehicleSelected = document.getElementById("vehicleSelected");
  vehicleSelected.append(' ' + selectOption4.value);
  
  partNumber = partTypeNumber;
  if((partNumber == null) || (partNumber == '')){ 
    partNumber = '' + thibertPartNumber;
    }
  
  if(partNumber.length == 5){
    partNumber = '0' + partNumber;
  }
  

  var arrModel = [];
  
    var link = apiURL+'/api/WhiteLabel/Questions/QuestionsByVehicleAndProduct/'+
        selectOption1.value+'/'+selectOption2.value+'/'+selectOption3.value+'/'+2+'/'+partNumber;
    var data = fetch(link, {

      method: 'GET',
      headers: {     
        "content-encoding": "gzip", 
        "content-length": "247",
        "content-type": "application/json; charset=utf-8", 
        "date": "Fri,30 Apr 2021 13:15:47 GMT",
        "request-context": "appId=cid-v1:c332b3e3-0008-434d-abd9-a1d6ea35f0dc",
        "server": "Microsoft-IIS/10.0",
        "vary": "Accept-Encoding", 
        "x-powered-by": "ASP.NET",
        "accept": "text/plain",
        "x-api-key": apiKey,
        "Authorization": apiKey
      }
    })
    .then(res => res.json())
    .then(data => { 
      data.questionsAnswers.forEach(Data => {
        if(Data.answers1[codeLG].localizedValue == selectOption4.value){
          if(Data.question2[codeLG].localizedValue){
            if(arrModel.includes(Data.answers2[codeLG].localizedValue) == false){  
              arrModel.push(Data.answers2[codeLG].localizedValue);  
              var OptionHidden5 = document.getElementById("OptionHidden5");
              OptionHidden5.innerText = Data.question2[codeLG].localizedValue;

              option5Li.style.display = "block";
              selectOption5.style.display = "block";

              var option = document.createElement("option");
              option.value = Data.answers2[codeLG].localizedValue;
              option.innerText = Data.answers2[codeLG].localizedValue;
              selectOption5.append(option);
            }
          }else{ 
            viewSelects();
          }    
        }
      });
    });
  }
function option5Function(){
  
   	var selectOption1 = document.getElementById("selectOption1");
    var selectOption2 = document.getElementById("selectOption2");
    var selectOption3 = document.getElementById("selectOption3");
    var selectOption4 = document.getElementById("selectOption4"); 
    var selectOption5 = document.getElementById("selectOption5"); 
    var selectOption6 = document.getElementById("selectOption6"); 
    selectOption1.style.display = "none";
    selectOption2.style.display = "none";
    selectOption3.style.display = "none";
    selectOption4.style.display = "none";
    selectOption5.style.display = "none";
  
  
    var optionLiText = document.getElementById("option5LiText");
    optionLiText.innerText = selectOption5.value;
    optionLiText.value = selectOption5.value;


  	var arrModel = [];
	  
    var link = apiURL+'/api/WhiteLabel/Questions/QuestionsByVehicleAndProduct/'+
        selectOption1.value+'/'+selectOption2.value+'/'+selectOption3.value+'/'+2+'/'+partNumber;
    var data = fetch(link, {

      method: 'GET',
      headers: {     
        "content-encoding": "gzip", 
        "content-length": "247",
        "content-type": "application/json; charset=utf-8", 
        "date": "Fri,30 Apr 2021 13:15:47 GMT",
        "request-context": "appId=cid-v1:c332b3e3-0008-434d-abd9-a1d6ea35f0dc",
        "server": "Microsoft-IIS/10.0",
        "vary": "Accept-Encoding", 
        "x-powered-by": "ASP.NET",
        "accept": "text/plain",
        "x-api-key": apiKey,
        "Authorization": apiKey
      }
    })
    .then(res => res.json())
    .then(data => { 
      data.questionsAnswers.forEach(Data => {
        
        if(Data.answers1[codeLG].localizedValue == selectOption4.value){
          if(Data.question3[codeLG].localizedValue){
            if(arrModel.includes(Data.answers3[codeLG].localizedValue) == false){  
              arrModel.push(Data.answers3[codeLG].localizedValue);  

              var OptionHidden6 = document.getElementById("OptionHidden6");
              OptionHidden6.innerText = Data.question3[codeLG].localizedValue;

              option6Li.style.display = "block";
              selectOption6.style.display = "block";

              var option = document.createElement("option");
              option.value = Data.answers3[codeLG].localizedValue;
              option.innerText = Data.answers3[codeLG].localizedValue;
              selectOption6.append(option);
            }
          } else{ 
            viewSelects();
          }         
        }
      });
    });
  }
function option6Function(){

   	var selectOption1 = document.getElementById("selectOption1");
    var selectOption2 = document.getElementById("selectOption2");
    var selectOption3 = document.getElementById("selectOption3");
    var selectOption4 = document.getElementById("selectOption4"); 
    var selectOption5 = document.getElementById("selectOption5"); 
    var selectOption6 = document.getElementById("selectOption6");
    var selectOption7 = document.getElementById("selectOption7"); 
    selectOption1.style.display = "none";
    selectOption2.style.display = "none";
    selectOption3.style.display = "none";
    selectOption4.style.display = "none";
    selectOption5.style.display = "none";
    selectOption6.style.display = "none";
  
  
    var optionLiText = document.getElementById("option6LiText");
    optionLiText.innerText = selectOption6.value;
    optionLiText.value = selectOption6.value;

  	var arrModel = [];

    var link = apiURL+'/api/WhiteLabel/Questions/QuestionsByVehicleAndProduct/'+
        selectOption1.value+'/'+selectOption2.value+'/'+selectOption3.value+'/'+2+'/'+partNumber;
    var data = fetch(link, {

      method: 'GET',
      headers: {     
        "content-encoding": "gzip", 
        "content-length": "247",
        "content-type": "application/json; charset=utf-8", 
        "date": "Fri,30 Apr 2021 13:15:47 GMT",
        "request-context": "appId=cid-v1:c332b3e3-0008-434d-abd9-a1d6ea35f0dc",
        "server": "Microsoft-IIS/10.0",
        "vary": "Accept-Encoding", 
        "x-powered-by": "ASP.NET",
        "accept": "text/plain",
        "x-api-key": apiKey,
        "Authorization": apiKey
      }
    })
    .then(res => res.json())
    .then(data => { 
      data.questionsAnswers.forEach(Data => {

        if(Data.answers1[codeLG].localizedValue == selectOption4.value){
          if(Data.question4[codeLG].localizedValue){
            
            if(arrModel.includes(Data.answers4[codeLG].localizedValue) == false){  
              arrModel.push(Data.answers4[codeLG].localizedValue);  
              
              var OptionHidden7 = document.getElementById("OptionHidden7");
              OptionHidden7.innerText = Data.question4[codeLG].localizedValue;

              option7Li.style.display = "block";
              selectOption7.style.display = "block";

              var option = document.createElement("option");
              option.value = Data.answers4[codeLG].localizedValue;
              option.innerText = Data.answers4[codeLG].localizedValue;
              selectOption7.append(option);
            }
          }else{ 
            viewSelects();
          }          
        }
      });
    });
  }
function option7Function(){

   	var selectOption1 = document.getElementById("selectOption1");
    var selectOption2 = document.getElementById("selectOption2");
    var selectOption3 = document.getElementById("selectOption3");
    var selectOption4 = document.getElementById("selectOption4"); 
    var selectOption5 = document.getElementById("selectOption5"); 
    var selectOption6 = document.getElementById("selectOption6");
    var selectOption7 = document.getElementById("selectOption7"); 
    var selectOption8 = document.getElementById("selectOption8"); 
    selectOption1.style.display = "none";
    selectOption2.style.display = "none";
    selectOption3.style.display = "none";
    selectOption4.style.display = "none";
    selectOption5.style.display = "none";
    selectOption6.style.display = "none";
    selectOption7.style.display = "none";
  
  
    var optionLiText = document.getElementById("option7LiText");
    optionLiText.innerText = selectOption7.value;
    optionLiText.value = selectOption7.value;


  	var arrModel = [];

    var link = apiURL+'/api/WhiteLabel/Questions/QuestionsByVehicleAndProduct/'+
        selectOption1.value+'/'+selectOption2.value+'/'+selectOption3.value+'/'+2+'/'+partNumber;
    var data = fetch(link, {

      method: 'GET',
      headers: {     
        "content-encoding": "gzip", 
        "content-length": "247",
        "content-type": "application/json; charset=utf-8", 
        "date": "Fri,30 Apr 2021 13:15:47 GMT",
        "request-context": "appId=cid-v1:c332b3e3-0008-434d-abd9-a1d6ea35f0dc",
        "server": "Microsoft-IIS/10.0",
        "vary": "Accept-Encoding", 
        "x-powered-by": "ASP.NET",
        "accept": "text/plain",
        "x-api-key": apiKey,
        "Authorization": apiKey
      }
    })
    .then(res => res.json())
    .then(data => { 
      data.questionsAnswers.forEach(Data => {

        if(Data.answers1[codeLG].localizedValue == selectOption4.value){
          if(Data.question5[codeLG].localizedValue){
            
            if(arrModel.includes(Data.answers5[codeLG].localizedValue) == false){  
              arrModel.push(Data.answers5[codeLG].localizedValue);  
              
              var OptionHidden8 = document.getElementById("OptionHidden8");
              OptionHidden8.innerText = Data.question5[codeLG].localizedValue;

              option8Li.style.display = "block";
              selectOption8.style.display = "block";

              var option = document.createElement("option");
              option.value = Data.answers5[codeLG].localizedValue;
              option.innerText = Data.answers5[codeLG].localizedValue;
              selectOption8.append(option);
            }
          } else{ 
            viewSelects();
          }         
        }
      });
    });
  }
function option8Function(){
  
   	var selectOption1 = document.getElementById("selectOption1");
    var selectOption2 = document.getElementById("selectOption2");
    var selectOption3 = document.getElementById("selectOption3");
    var selectOption4 = document.getElementById("selectOption4"); 
    var selectOption5 = document.getElementById("selectOption5"); 
    var selectOption6 = document.getElementById("selectOption6");
    var selectOption7 = document.getElementById("selectOption7"); 
    var selectOption8 = document.getElementById("selectOption8"); 
    selectOption1.style.display = "none";
    selectOption2.style.display = "none";
    selectOption3.style.display = "none";
    selectOption4.style.display = "none";
    selectOption5.style.display = "none";
    selectOption6.style.display = "none";
    selectOption7.style.display = "none";
    selectOption8.style.display = "none";
  
  
    var optionLiText = document.getElementById("option8LiText");
    optionLiText.innerText = selectOption8.value;
    optionLiText.value = selectOption8.value;
    
      viewSelects();
    }  
function viewSelects(){

  var selectOption1 = document.getElementById("selectOption1");
  var selectOption2 = document.getElementById("selectOption2");
  var selectOption3 = document.getElementById("selectOption3");
  var selectOption4 = document.getElementById("selectOption4"); 
  var selectOption5 = document.getElementById("selectOption5"); 
  var selectOption6 = document.getElementById("selectOption6");
  var selectOption7 = document.getElementById("selectOption7"); 
  var selectOption8 = document.getElementById("selectOption8"); 
  selectOption1.style.display = "none";
  selectOption2.style.display = "none";
  selectOption3.style.display = "none";
  selectOption4.style.display = "none";
  selectOption5.style.display = "none";
  selectOption6.style.display = "none";
  selectOption7.style.display = "none";
  selectOption8.style.display = "none";

  var idGo = document.getElementById("idGo");
  idGo.style.display = 'block';
  
  idGo.href = querypathname + '?subModel=' + selectOption4.value + '&partNumber=' + partNumber;
  
} 
/*  
$( document ).ready(function() {
if((subModel != null)){
  $("#product_form_").append("<input type='hidden' name='properties[Fitment]' value='"+year+" "+make+" "+model+" "+subModel+"'>");
    }
    
}); 
*/
});

$( document ).ready(function() {
  $('.in-stock-notification-form button').click(function(){
    var valueInput = $('#static-product-in-stock-notification-form-email')[0].value;
    var myLocation = location.href;
    if (valueInput.indexOf("@") >= 0){
      if (myLocation.indexOf("partNumber") >= 0){
        location.href = myLocation + '&contact_posted=true';
      }
    }
  })
}); 